import { Component, OnInit, Input } from '@angular/core';
import { BsModalService } from "ngx-bootstrap";
import { ApiService, VOC } from "../../../../../../projects/accounting/src/public_api";

export interface DetailsViewerData {
  customer: VOC;
  period: string;
}

interface ApiRecord {
  ID: number;
  Name: string;
  Address: string;
  Amount: number;
}

@Component({
  selector: 'customer-details-viewer',
  templateUrl: './details-viewer.component.html',
  styleUrls: ['./details-viewer.component.scss']
})
export class DetailsViewerComponent implements OnInit {

  @Input() data: DetailsViewerData;

  loading = false;

  records: Array<ApiRecord> = [];
  total: number = 0;

  constructor(
    private bsModal: BsModalService,
    private api: ApiService
  ) { }

  ngOnInit() {

    this.total = 0;

    this.loading = true;
    console.log(this.data);

    this.api.debtOfCustomer({ ID: this.data.customer.id, Period: this.data.period }).subscribe(response => {

      this.records = response.succeed && response.data != null ? response.data : [];
        this.records.forEach(i => this.total += i.Amount);

        this.loading = false;
      },
    );
  }
}
